import script from "./ClientBondsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientBondsIndex.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__